export default __webpack_public_path__ + "static/media/logo1.2e7d9888.png";